import { uniqueId } from 'lodash';
import { IVendor, IVendorCode, IVendorCodeOverride } from 'src/types/IVendor';
import { getCurrentYearMonth } from 'src/util/dateTimeUtil';

export const serviceOptions = ['All', 'AMU', 'Prime', 'Prime IN', 'Prime legacy', 'AMF', 'AMP'];

export const territoryOptions = ['JP - Japan', 'US - United States', 'Global'];

export const newVendorCode = (): IVendorCode => ({
    vendorCodeId: uniqueId(),
    catalogCode: '',
    royaltyCode: '',
    mappingStart: getCurrentYearMonth('-') + '-01',
    mappingEnd: '',
    isNewVendorCode: true
});

export const newVendorCodeOverride = (): IVendorCodeOverride => ({
    vendorCodeId: uniqueId(),
    catalogCode: '',
    royaltyCode: '',
    serviceId: undefined,
    serviceName: '',
    territoryId: undefined,
    territoryName: '',
    mappingStart: getCurrentYearMonth('-') + '-01',
    mappingEnd: '',
    isNewVendorCode: true
});

export const initialAddVendorState: IVendor = {
    vendorName: '',
    description: '',
    vendorCodes: [newVendorCode()],
    vendorCodeOverrides: [],
    submitAccruals: true,
    submitPayments: false
};
